import React, { FC } from 'react'
import { useScreenClass } from 'react-grid-system'
import styled from 'styled-components'

const Section = styled.section<{ isDesktop: boolean }>`
  position: relative;
  overflow: hidden;
  z-index: 2;
  height: ${(props) => (props.isDesktop ? '150px' : '104px')};
  background: linear-gradient(62deg, #6B000D 0%, #990000 58%, #D52027 100%);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /* soft off-centre glow keeps the flat gradient from looking like a slab */
  &::before {
    content: '';
    position: absolute;
    top: -60%;
    right: -10%;
    width: 55%;
    height: 220%;
    background: radial-gradient(
      ellipse at center,
      rgba(213, 32, 39, 0.42) 0%,
      rgba(213, 32, 39, 0) 68%
    );
    pointer-events: none;
  }

  /* thin brand rule along the bottom edge */
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 3px;
    background: linear-gradient(
      62deg,
      rgba(255, 255, 255, 0.85) 0%,
      rgba(255, 255, 255, 0.35) 45%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  h1 {
    position: relative;
    font-size: var(--fs-display-lg);
    font-weight: 700;
    margin: 0;
    color: white;
    text-align: center;
    padding: 0 1rem;
  }
`

const Rule = styled.span<{ isDesktop: boolean }>`
  position: relative;
  display: block;
  width: ${(props) => (props.isDesktop ? '56px' : '40px')};
  height: 3px;
  border-radius: 2px;
  margin-top: ${(props) => (props.isDesktop ? '0.9rem' : '0.6rem')};
  background: rgba(255, 255, 255, 0.9);
`

const SecondaryHero: FC = ({ children }) => {
  const screenClass = useScreenClass()
  const isDesktop = ['lg', 'xl'].includes(screenClass)

  return (
    <Section isDesktop={isDesktop}>
      <h1>{children}</h1>
      <Rule isDesktop={isDesktop} aria-hidden="true" />
    </Section>
  )
}

export default SecondaryHero
